export class ControlButton {
  icon: string;
  text: string;
  visible: boolean;
  active?: boolean;

  action: () => Promise<void>;
}
export class HeaderButton {
  icon: string;
  statfullButton: boolean;
  toolTipContent: string;
  active: boolean;
  action: () => Promise<void>;
  id?: number;
  disabled?: boolean;
  caption?: string;
}

export class FilterOption {
  searchMode: SearchMode;
  caption: string;
  icon: string;
}

export enum SearchMode {
  Contains = 'contains',
  NotContains = 'notcontains',
  StartsWith = 'startswith',
  EndsWith = 'endswith',
  Equals = '=',
  NotEqual = '<>',
  Greater = '>',
  GreaterOrEqual = '>=',
  Less = '<',
  LessOrEqual = '<=',
  IsLike = 'equals',
  NotLike = '<>',
}

export enum ColumnTypeIcon {
  preferences = 'preferences',
  key = 'key',
  box = 'box',
  reference = 'movetofolder',
  referencing = 'mediumiconslayout',
}
